export default __webpack_public_path__ + "static/media/date.16710130.svg";